<div class="flex w-full">
    <mat-icon 
        matTooltip="Download File" 
        class="material-icons-outlined"
        (click)="onClick()"
    >
        download
    </mat-icon>
</div>